<template>
    <div v-if="colldata && colldata.records.length" class="page max-width">
      <!-- 卡片视图 -->
      <div v-if="grid" class="mach-width flex data-content-grid">
        <div v-for="(item,index) in colldata.records" :key="index" class="data-content-grid-item" :class="index%3==2?'':'data-content-grid-itemspace'">
          <div class="data-content-grid-item-img position-relative">
            <!-- <el-image class="img mach-height mach-width" :src="item.preview" fit="cover" :lazy="true" /> -->
            <div class="img mach-height mach-width cursor" :style="{backgroundImage: 'url(' + item.preview + ')','background-position':'center','background-size':'cover'}" @click="toDetail(item)" />
  
            <div v-if="item.pictureNumber>0 || item.videoNumber>0 || item.audioNumber>0 || item.otherNumber>0" class="data-content-grid-item-img-count flex-row-align-center position-absolute radius-clip-5">
              <div v-if="item.pictureNumber>0" class="space flex-row-align-center">
                <img src="@/assets/icon-lib-pic-count.png">
                <span class="font-color-white font-size-11">{{ item.pictureNumber }}</span>
              </div>
              <div v-if="item.videoNumber>0" class="space flex-row-align-center">
                <img src="@/assets/icon-lib-video-count.png">
                <span class="font-color-white font-size-11">{{ item.videoNumber }}</span>
              </div>
              <div v-if="item.audioNumber>0" class="space flex-row-align-center">
                <img src="@/assets/icon-lib-audio-count.png">
                <span class="font-color-white font-size-11">{{ item.audioNumber }}</span>
              </div>
              <div v-if="item.otherNumber>0" class="space flex-row-align-center">
                <img src="@/assets/icon-lib-file-count.png">
                <span class="font-color-white font-size-11">{{ item.otherNumber }}</span>
              </div>
            </div>
          </div>
          <div class="data-content-grid-item-info">
            <div class="data-content-grid-item-info-tit cursor" @click="toDetail(item)">
              <!-- {{ item.collectionName }} -->
              <p class="font-size-16 font-color-264480 text-line-2 font-bold font-title" v-html="item.collectionName" />
            </div>
            <div class="data-content-grid-item-info-desc cursor" @click="toDetail(item)">
              <!-- {{ item.description }} -->
              <p class="font-size-14 font-color-666 text-line-3 collitem-desc" v-html="item.description" />
            </div>
          </div>
        </div>
      </div>
      <!-- 列表视图 -->
      <div v-else class="mach-width">
        <div v-for="(item,index) in colldata.records" :key="index" class="data-content-item cursor flex">
          <div class="data-content-item-img cursor" @click="toDetail(item)">
            <div class="img" :style="{backgroundImage: 'url(' + item.preview + ')','background-position':'center','background-size':'cover'}" />
          </div>
          <div class="data-content-item-info flex-1">
            <!-- {{ item.collectionName }} -->
            <p class="text-line-2 font-title cursor" @click="toDetail(item)" v-html="item.collectionName" />
            <!-- {{ item.description }} -->
            <p class="text-line-3 font-size-14 font-color-666 collitem-desc cursor" @click="toDetail(item)" v-html="item.description" />
            <div class="data-content-item-info-mark flex">
              <div class="data-content-item-info-mark-item flex-row-align-center">
                <p class="font-bold font-size-14">资源</p>
                <div class="data-content-item-info-mark-item-wrap flex-row-align-center">
                  <p v-if="item.pictureNumber>0" class="font-size-12 font-color-666">{{ item.pictureNumber }}图片</p>
                  <p v-if="item.videoNumber>0" class="font-size-12 font-color-666">{{ item.videoNumber }}视频</p>
                  <p v-if="item.audioNumber>0" class="font-size-12 font-color-666">{{ item.audioNumber }}音频</p>
                  <p v-if="item.otherNumber>0" class="font-size-12 font-color-666">{{ item.otherNumber }}其他</p>
                </div>
              </div>
              <div class="data-content-item-info-mark-item flex-row-align-center">
                <p class="font-bold font-size-14 flex-shrink">发布</p>
                <div class="data-content-item-info-mark-item-wrap flex-row-align-center">
                  <p v-if="item.commitByType == 1" class="font-size-12 data-content-item-info-mark-item-wrap-text flex-shrink text-line-1" @click.stop="pubmanSearch(item)">{{ item.submitterName || '' }}</p>
                  <p v-else-if="item.commitByType == 2" class="font-size-12 data-content-item-info-mark-item-wrap-text flex-shrink text-line-1" @click.stop="pubmanSearch(item)">{{ item.submitterName || '' }}</p>
                  <p class="font-size-12 font-color-666 text-line-1 flex-shrink">{{ item.publisherTime }}</p>
                </div>
              </div>
              <div class="data-content-item-info-mark-item flex-row-align-center">
                <p class="font-bold font-size-14">分类</p>
                <div class="flex flex-row-align-center" style="padding-left: 20px;">
                  <div v-for="(cate,idx) in item.listCategory" :key="idx" class=" flex-row-align-center data-content-item-info-mark-item-wrap-cate" @click.stop="cateToSearch(cate)">
                    <p class="font-size-12 data-content-item-info-mark-item-wrap-text">{{ cate.cateName }}</p>
                    <p class="font-size-12 font-color-666">/</p>
                  </div>
                </div>
              </div>
              <div class="data-content-item-info-mark-item flex-row-align-center">
                <p class="font-bold font-size-14">版权</p>
                <div class="data-content-item-info-mark-item-wrap flex-row-align-center">
                  <p class="font-size-12 font-color-666">{{ item.copyrightOwner }}</p>
                </div>
              </div>
              <div v-if="item.subjectList.length" class="data-content-item-info-mark-item flex-row-align-center">
                <p class="font-bold font-size-14">学科</p>
                <div class="flex flex-row-align-center" style="padding-left: 20px;">
                  <div v-for="(cate,idx) in item.subjectList" :key="idx" class=" flex-row-align-center data-content-item-info-mark-item-wrap-cate" @click.stop="subjectToSearch(cate)">
                    <p class="font-size-12 data-content-item-info-mark-item-wrap-text">{{ cate.subjectName }}</p>
                    <p class="font-size-12 font-color-666">/</p>
                  </div>
                </div>
              </div>
              <div v-if="item.topicName" class="data-content-item-info-mark-item flex-row-align-center">
                <p class="font-bold font-size-14">专题</p>
                <div class="data-content-item-info-mark-item-wrap flex-row-align-center" @click="topicToSearch(item)">
                  <p class="font-size-12  data-content-item-info-mark-item-wrap-text">{{ item.topicName }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="user-empty flex flex-center mach-width">
      <p class=" font-size-14 font-color-666">暂无内容</p>
    </div>
  </template>
  
  <script>
  
  // import user from '../../../../../models/user.js'
  import user from '@/models/user.js'
  export default {
    name: 'CollectionComponnents',
    props: {
      grid: {
        type: Boolean,
        default: false
      },
      colldata: {
        type: Object,
        require: true,
        default: null
      }
    },
    data(){
      return{
        // loading: true
      }
     
    },
    methods: {
      toDetail(v) {
        const routeData = this.$router.resolve({
          name: 'Resource',
          query: {
            rsId: v.id,
            permission: v.permissionRange
          }
        })
        window.open(routeData.href, '_blank')
      },
      cateToSearch(v) {
        this.$emit('params', { params: { categoryId: v.id }, display: v.cateName, type: 'categoryId' })
      },
      pubmanSearch(v) {
        if (v.commitByType === 1) {
          this.$emit('params', { params: { commitBy: v.createUser }, display: v.submitterName, type: 'commitBy' })
        } else {
          this.$emit('params', { params: { commitBy: v.createUser }, display: v.submitterName, type: 'commitBy' })
        }
      },
      topicToSearch(v) {
        this.$emit('params', { params: { specialSubject: v.topicId }, display: v.topicName, type: 'specialSubject' })
      },
      subjectToSearch(v) {
        this.$emit('params', { params: { subjects: v.id }, display: v.subjectName, type: 'subjects' })
      }
    }
  }
  </script>
  
  <style src="@/styles/pc.css" scoped>
  </style>
  <style scoped>
  
  .data-content-grid {
    flex-wrap: wrap;
    /* padding-top:30px */
  }
  
  .data-content-grid-item {
    width: 280px;
    margin-bottom: 20px;
  }
  
  .data-content-grid-itemspace {
    margin-right: 40px;
  }
  
  .data-content-grid-item-img {
    width: 100%;
    height: 186px;
    overflow: hidden;
    border-radius: 5px;
  }
  
  .data-content-grid-item-img-count {
      bottom: 5px;
      right: 5px;
      height: 20px;
      padding: 0 9px 0 4px;
      background-color: rgba(0, 0, 0, 0.6);
    }
  
    .data-content-grid-item-img-count .space {
      margin-right: 4px;
    }
  
    .data-content-grid-item-img-count .space:last-child {
      margin: 0;
    }
  
    .data-content-grid-item-info-tit {
      margin-top: 9px;
      height: 54px;
    }
  
    .data-content-grid-item-info-desc {
      height: 74px;
    }
  
    .data-content-item-img {
      width: 280px;
      /* height: 186px; */
      padding-top: 30px;
      /* overflow: hidden; */
      border-radius: 5px;
    }
  
    .data-content-item-img .img {
      width: 280px;
      height: 186px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 5px;
    }
  
    .data-content-item-info {
      padding-top: 30px;
      padding-left: 40px;
    }
  
    .data-content-item-info-mark {
      flex-wrap: wrap;
    }
  
    .data-content-item-info-mark-item {
      width: 50%;
      height: 30px;
    }
  
    .data-content-item-info-mark-item-wrap {
      margin-left:20px;
    }
  
    .data-content-item-info-mark-item-wrap p {
      margin-right: 8px;
    }
  
    .data-content-item-info-mark-item-wrap-text {
      cursor: pointer;
      color: #264480;
      text-decoration: underline;
    }
  
  /* add by sxz */
    .data-content-item .collitem-desc{
      line-height: 20px;
      margin-bottom: 15px;
      letter-spacing: .5px;
    }
  
    .data-content-item-info-mark-item-wrap-cate:last-child p:last-child {
      display: none;
    }
  
    .user-empty{
      height: 400px;
    }
  
  .data-content-grid-item .collitem-desc{
    line-height: 20px;
    /* margin-bottom: 15px; */
    letter-spacing: .5px;
  }
  
  </style>
  